module.exports = __webpack_public_path__ + "assets/img/30-l.ea25a48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/30-l.jpg
// module id = woGB
// module chunks = 0